import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDeleteProject } from './api_project';

const initialState = {};

export const fetchDeleteProjectData = createAsyncThunk(
  'ui/fetchDeleteProjectData',
  async (obj, thunkAPI) => {
    const { getState } = thunkAPI;
    const response = await getDeleteProject(obj);
    return response.data;
  }
);

const deleteStatusSlice = createSlice({
  name: 'deleteStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeleteProjectData.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          statusDataLoaded: false,
          statusFetchFailed: false,
          statusData: initialState,
        };
      })
      .addCase(fetchDeleteProjectData.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'idle',
          statusData: action.payload,
          statusFetchFailed: false,
          statusDataLoaded: true,
        };
      })
      .addCase(fetchDeleteProjectData.rejected, (state) => {
        return {
          ...state,
          statusFetchFailed: true,
          status: 'idle',
          statusDataLoaded: true,
        };
      });
  },
});

export const getDeleteStatus = (state) => state.deleteStatus?.statusData;

export default deleteStatusSlice.reducer;
